import React, { useEffect, useState } from 'react';
import MsgUtils from '../Tools/MsgUtils';
import UtilsBufer from '../Tools/UtilsBufer';
import DateConverter from '../Tools/DateConverter';
import ConsultasFormularios from '../Sql/ConsultasFormularios';
import ContenidoFormulario from './ContenidoFormulario';
import EncuestaRespond from './EncuestaRespond';

function ListaFormularios(props) {
    const { selectColaborador, collback, tipo,tipoFormulario,regional } = props;
    const [infoSession, setInfoSession] = useState(null);
    const [encuestas, setEncuestas] = useState([]);
    const [selectItem, setSelectItem] = useState(null);
    const [ventana, setVentana] = useState(0);
    const [soloVer, setSoloVer] = useState(false);
    const [selectRespuesta, setSelectRespuesta] = useState(null);
    const [idFormulario, setIdFormulario] = useState(null);
    const getEncuestas = async () => {
        try {
            var infoInit = JSON.parse(localStorage.getItem("__react_session__"));
            setInfoSession(infoInit)
            var encuestas = await ConsultasFormularios.getEvaluaciones({ regional: regional, tipo: tipoFormulario });
            if (encuestas.ok) {
                setEncuestas(encuestas.ok);
            } else {
                MsgUtils.msgError(encuestas.error);
            }
        } catch (error) {
            MsgUtils.msgError(error.message)
        }
    }
    const asignarFormulario = async (encuesta) => {
        try {
            var respuesta = await ConsultasFormularios.saveFormulario({
                'regional': regional,
                'idEncuesta': encuesta.ID_ENCUESTA, 'creadoPor': infoSession.idSession,
                'idEmpleado': selectColaborador.ID_EMPLEADO, 'idFormulario': 0
            })
            if (respuesta.ok) {
                setIdFormulario(respuesta.ok);
                setSelectItem({ ...encuesta, 'ID_RESPUESTA': 0 });
                setVentana(1);
                setSoloVer(true);
                MsgUtils.msgCorrecto("Formulario Asignado");
            } else {
                MsgUtils.msgError(respuesta.error);
            }
        } catch (error) {
            MsgUtils.msgError(error.message);
        }
    }
    const asignarEvaluacion = async () => {
        try {
            var respuesta = await ConsultasFormularios.saveFormulario(
                {
                    'regional': regional,
                    'idEncuesta': selectItem.ID_ENCUESTA, 'creadoPor': infoSession.idSession,
                    'idEmpleado': selectColaborador.ID_EMPLEADO, 'idFormulario': 0
                });
            if (respuesta.ok) {
                collback()
            } else {
                MsgUtils.msgError(respuesta.error);
            }
        } catch (error) {
            MsgUtils.msgError(error.message);
        }
    }
    const guardarRespuesta = async (valor) => {
        try {
            var respuesta = await ConsultasFormularios.guardarRespuestaFormulario(
                {
                    'regional': regional, 'ID_RESPUESTA': valor,
                    'ID_FORMULARIO': idFormulario, 'ID_EMPLEADO': infoSession.idSession
                })
            if (respuesta.ok) {
                collback()
            } else {
                MsgUtils.msgError(respuesta.error);
            }
        } catch (error) {
            MsgUtils.msgError(error.message);
        }
    }
    useEffect(() => {
        getEncuestas()
    }, [])
    return (
        <>
            {ventana == 0 && <div className='tabla-responsive'>
                <table className='table table-sm table-dark table-striped table-hover table-bordered border-secondary'>
                    <thead>
                        <tr>
                            <th>Titulo</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {encuestas.map((encuesta, index) => {
                            return (
                                <tr key={index}>
                                    <td>{encuesta.TITULO}</td>
                                    <td className='text-end '>
                                        {tipo == 'RD' && <button className='btn btn-sm btn-transparent text-light'
                                            title='Ver el contenido del formulario'
                                            onClick={() => asignarFormulario(encuesta)}>
                                            <i className="fa-solid fa-eye fs-5"></i>
                                        </button>}
                                        {tipo == 'VP' && <button className='btn btn-sm btn-transparent text-light'
                                            title='Ver el contenido del formulario'
                                            onClick={() => { setSelectItem(encuesta); setVentana(1); console.log(encuesta) }}>
                                            <i className="fa-solid fa-eye fs-5"></i>
                                        </button>}
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>}
            {ventana == 1 && tipo == 'RD' &&
                <div className='overflow-auto mb-1' style={{ height: `${window.innerHeight - window.innerHeight * 0.20}px`, margin: 0, padding: 0 }}>
                    <EncuestaRespond selectFormu={selectItem} soloVer={false} 
                        teclado={false} tipo='F' collback={(dato) => guardarRespuesta(dato)} 
                        reg={regional} userResp={selectColaborador}/>
                </div>}
            {ventana == 1 && tipo == 'VP' && <>
                <div className='overflow-auto mb-1' style={{ height: `${window.innerHeight - window.innerHeight * 0.20}px`, margin: 0, padding: 0 }}>
                    <ContenidoFormulario selectItem={selectItem} setVentana={setVentana} regional={infoSession.regional}
                        soloVer={true} setLoader={() => { }} selectRespuesta={null} setSelectRespuesta={() => { }} setVerRespuesta={() => { }} />
                </div>
                <div className='container-fluid text-center mb-2'>
                    <button className='btn btn-sm btn-success w-50'
                    onClick={()=>asignarEvaluacion()}>
                        <i className="fa-solid fa-check"></i> Elegir Encuesta
                    </button>
                </div>
            </>
            }
        </>
    )
}

export default ListaFormularios